<template>
  <header
    class="sticky top-0 z-50 w-full border-b border-border bg-card/95 text-foreground shadow-sm backdrop-blur-xl transition-colors"
  >
    <nav class="mx-auto flex w-full max-w-6xl items-center justify-between gap-2 px-4 py-4 sm:px-6 lg:px-10">
      <RouterLink
        to="/"
        class="min-w-0 flex items-center gap-2 text-foreground transition hover:opacity-80 sm:gap-3"
      >
        <div
          class="flex h-10 w-10 items-center justify-center rounded-full border border-primary/35 bg-primary/10 font-serif text-lg font-semibold"
        >
          ر
        </div>
        <div class="hidden min-w-0 text-left sm:block">
          <p class="text-sm font-semibold tracking-tight">Rattil</p>
        </div>
      </RouterLink>

      <div
        class="hidden items-center gap-1 rounded-full border border-border bg-muted/70 px-1 py-1 text-sm font-medium text-muted-foreground shadow-lg shadow-black/5 lg:flex"
      >
        <RouterLink
          v-for="item in navItems"
          :key="item.to"
          :to="item.to"
          class="flex items-center gap-2 rounded-full px-4 py-2 transition-all"
          :class="$route.path === item.to
            ? 'bg-primary text-primary-foreground'
            : 'hover:bg-background hover:text-foreground'"
        >
          <component :is="item.icon" :size="16" />
          <span>{{ item.label }}</span>
        </RouterLink>
      </div>

      <div class="flex shrink-0 items-center gap-2 sm:gap-3">
        <Button
          variant="ghost"
          size="icon"
          class="h-10 w-10 rounded-full border border-border bg-background text-foreground hover:bg-muted"
          :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
          @click="toggleTheme"
        >
          <PhSun v-if="isDark" :size="20" />
          <PhMoon v-else :size="20" />
        </Button>

        <UserAuthMenu />

        <Button
          variant="ghost"
          size="icon"
          class="h-10 w-10 rounded-full border border-border text-foreground hover:bg-muted lg:hidden"
          @click="mobileMenuOpen = !mobileMenuOpen"
          aria-label="Toggle navigation"
        >
          <PhX v-if="mobileMenuOpen" :size="22" />
          <PhList v-else :size="22" />
        </Button>
      </div>
    </nav>

    <transition name="fade">
      <div
        v-if="mobileMenuOpen"
        class="border-t border-border bg-card px-6 py-4 text-foreground lg:hidden"
      >
        <div class="space-y-2">
          <RouterLink
            v-for="item in navItems"
            :key="item.to + '-mobile'"
            :to="item.to"
            class="flex items-center gap-3 rounded-2xl border px-4 py-3 text-sm transition"
            :class="[
              'border-border hover:border-primary/40 hover:bg-muted',
              $route.path === item.to ? 'border-primary bg-primary/10 text-primary' : '',
            ]"
            @click="mobileMenuOpen = false"
          >
            <component :is="item.icon" :size="18" />
            <div class="flex flex-col">
              <span class="font-semibold">{{ item.label }}</span>
              <span class="text-xs text-muted-foreground">{{ item.subtitle }}</span>
            </div>
          </RouterLink>
        </div>
      </div>
    </transition>
  </header>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { RouterLink, useRoute } from 'vue-router'
import { PhHouse, PhBookOpen, PhGraduationCap, PhList, PhMoon, PhSun, PhX } from '@phosphor-icons/vue'
import { Button } from '@/components/ui/button'
import UserAuthMenu from '@/components/auth/UserAuthMenu.vue'
import { useTheme } from '@/composables/useTheme'

const route = useRoute()
const mobileMenuOpen = ref(false)
const { isDark, toggleTheme } = useTheme()

const navItems = [
  { to: '/', label: 'Home', icon: PhHouse, subtitle: 'Landing' },
  { to: '/quran', label: 'Qur’an', icon: PhBookOpen, subtitle: 'Page reader' },
  { to: '/learn', label: 'Learn', icon: PhGraduationCap, subtitle: 'Tajweed course' },
]

watch(
  () => route.path,
  () => {
    mobileMenuOpen.value = false
  },
)
</script>
